import React, { Component } from 'react';
import { connect } from 'react-redux';
import { submit } from "redux-form";
import { withRouter } from 'react-router';
import { Scrollbars } from 'react-custom-scrollbars';
import { Button } from 'reactstrap';


import Aux from '../../../system/containers/Aux';
import Loading from '../../../system/components/Loading';
import FormWrapper from '../../../system/components/FormWrapper';
import FlexWrapper from '../../../system/components/FlexWrapper';
import { validateUser } from '../../../system/utils/UserPermissions';
import Form from '../../Hotels/Form';

import { actionCreators } from '../../../store/hotels';
import {getHotels} from "../../../store/overview";

class DealNewHotelWrapper extends Component {
  constructor(props) {
    super(props);

    this.state = {
      requiredPermissions: ["CREATE_HOTEL", "ALL"]
    };
  }

  submit = values => {
    this.props.dispatch(actionCreators.create(values));
  };

  componentWillMount() {
    validateUser(this.props.permissions, this.state.requiredPermissions);
  }

  render() {
    const props = this.props;
    return (
      <Aux>
        <Form onSubmit={this.submit} mode="create" />
        <Button
          color="success"
          disabled={props.loading}
          onClick={() => { props.dispatch(submit("HotelForm")); window.setTimeout(() => {props.dispatch(getHotels()) }, 1000) } }
        >
          Save Hotel
        </Button>
      </Aux>
    )
  }
}

function mapStateToProps(store) {
  return {
    permissions: store.auth.permissions,
    loading: store.test.loading,
    data: store.test.entry
  }
}

export default connect(mapStateToProps)(DealNewHotelWrapper);


// WEBPACK FOOTER //
// ./src/containers/Deals/components/DealNewHotelWrapper.jsx